import styled from 'styled-components';
import rtl from 'styled-components-rtl';
//TODO: will be removed in future when found proper solution
/* eslint-disable-next-line @nx/enforce-module-boundaries */
import { theme } from '@marriott/mi-ui-library-shop';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledPropertyCardPriceDiv = styled.div`
  ${rtl`

    .amount-display {
    &:dir(rtl) {
      display: flex;
      align-items: baseline;
      float: right;
      flex-direction: row;
    }
  }
 
  .points-mandatory-fee-section{
    font-size: ${toRem(12)};
    line-height: ${toRem(18)};
    @media only ${baseVariables.mediaQuery.md} {
      max-width: ${toRem(190)};
    }
    @media only ${baseVariables.mediaQuery.lg} {
      max-width: unset;
    }
  }
  .nowrap-tooltip{
    white-space: nowrap;
  }
  .price-section-map-view-max-width{
    max-width: ${toRem(198)};
    
  }
  .points-mandatory-fee-section-hqv {
    font-size: ${toRem(12)};
    line-height: ${toRem(18)};
  }
  .points-mandatory-fee-text {
    @media only ${baseVariables.mediaQuery.md} {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      display: block;
    }
    @media only ${baseVariables.mediaQuery.lg} {
     white-space: unset;
      overflow: unset;
      text-overflow: unset;
      display: unset;

    }
  }
 
  .points-mandatory-fee-icon-map-view{
    &::before {
      bottom: ${toRem(-14)};
      position: relative;
      left: ${toRem(2)};
    }
  }
  .point-savers-mandatory-fee-icon-map-view{
    white-space: normal;
    &::before {
      bottom: ${toRem(-1)};
      position: relative;
    }
  }
  .points-mandatory-fee-icon-mobile-and-map{
    font-size: ${baseVariables.font.fontXs};
    display:inline-block;
    margin-top:${toRem(-4)};
  }

  .multi-digit {
    // @media only ${theme.mediaQuery.allMobiles} {
      flex-direction: column !important;
        // }
  }
  .taxes-and-fees-de {
    width: ${toRem(150)};
    text-align: right;
  }
  .tablet-map-view {
    display:none !important;
    @media only ${theme.mediaQuery.allTablets} {
      display:flex !important;
    }
  }
  
  .idr-currency-label{
      margin-left:${toRem(5)} !important;
      line-height:${toRem(14)} !important;
    }

   /*TODO : The below class m-price is added as a part of FSD-73576
   it can be removed once the global styles are updated */

  .m-price {
    font-size: ${toRem(22)};
    line-height: ${toRem(24)};
  }
  .price-map-view {
    display:flex !important;
    @media only ${theme.mediaQuery.allTablets} {
      display:none !important;
    }
  }

  .points-saver {
    color: ${theme.color['verdun-green']};
    text-align: right;
  }

  .strike-through {
    text-decoration: line-through;
    display: flex;
    align-items: center;
    color: ${theme.color['dark-gray-13']};
  }
  .strike-through-component{
    padding-right: ${toRem(6)};
  }
  .eeo-price-value{
    line-height: ${toRem(14)} !important;
  }
  .map-currency-value{
    display: flex;
    align-items: end;
    .map-price-value{
      line-height: ${toRem(24)};
      display: flex;
      align-items: end;
    }
  }
  @media only ${theme.mediaQuery.allTablets} {
    .map-currency-value{
      display: block;
      .map-price-value{
        display: contents;
      }
    }
  }
  .currency-label {
    margin-left: ${toRem(5)};
  }
  .currency-value{
   text-align: right;
    @media only ${theme.mediaQuery.allMobiles} {
      gap: ${toRem(1)};
      align-items: baseline;
      justify-content: flex-end;
    }
  }
  .rate-container {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content:flex-end;

    .rate-unavailable {
      @media only ${theme.mediaQuery.minDesktop} {
        padding: ${toRem(4)} 0 ${toRem(3)};
      }

      @media only ${theme.mediaQuery.allMobiles} {
        padding: ${toRem(4)} 0 ${toRem(3)};
      }
    }
  }
  `}
`;
